// extracted by mini-css-extract-plugin
export var header = "_fp-0";